var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertifiedFrameless(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "159px",
    height: "64px",
    viewBox: "0 0 188 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "imgs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M-4.73695157e-15,13.3350002 C-4.73695157e-15,20.7012543 5.97066667,26.6700004 13.3333333,26.6700004 L13.3333333,26.6700004 C16.8693333,26.6700004 20.2613333,25.2671584 22.7613333,22.7655124 L22.7613333,22.7655124 C25.2626667,20.2651998 26.6666667,16.8727758 26.6666667,13.3350002 L26.6666667,13.3350002 C26.6666667,5.97141309 20.6973333,0 13.3333333,0 L13.3333333,0 C5.97066667,0 -4.73695157e-15,5.97141309 -4.73695157e-15,13.3350002 L-4.73695157e-15,13.3350002 Z M2.66666667,13.3350002 C2.66666667,7.44493062 7.44266667,2.66700004 13.3333333,2.66700004 L13.3333333,2.66700004 C19.224,2.66700004 24,7.44493062 24,13.3350002 L24,13.3350002 C24,19.2277368 19.224,24.0030004 13.3333333,24.0030004 L13.3333333,24.0030004 C7.44266667,24.0030004 2.66666667,19.2277368 2.66666667,13.3350002 L2.66666667,13.3350002 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.786158,0.534733508 L5.45282463,8.08234363 L2.19949129,4.84060508 C1.67149129,4.38588157 0.882157962,4.41788557 0.390157962,4.91128058 L0.390157962,4.91128058 C-0.101842038,5.40334208 -0.132508705,6.1914406 0.320824628,6.72084011 L0.320824628,6.72084011 L4.54749129,10.9213652 C4.79815796,11.1707297 5.13815796,11.3107472 5.49415796,11.3094231 L5.49415796,11.3094231 L5.49415796,11.2547402 C5.85015796,11.2534067 6.19149129,11.1093887 6.43949129,10.8546902 L6.43949129,10.8546902 L14.7194913,2.34562654 C15.1088246,2.01358503 15.274158,1.48951952 15.1434913,0.994791016 L15.1434913,0.994791016 C15.0114913,0.500062508 14.6114913,0.124015502 14.1088246,0.0240030004 L14.1088246,0.0240030004 C14.0234913,0.00800100013 13.9394913,0 13.8554913,0 L13.8554913,0 C13.4408246,0 13.0408246,0.193357503 12.786158,0.534733508 L12.786158,0.534733508 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.6688336 C0,10.3506272 2.98266667,13.3350002 6.66533333,13.3350002 L6.66533333,13.3350002 C10.348,13.3350002 13.3333333,10.3506272 13.3333333,6.6688336 L13.3333333,6.6688336 C13.3333333,2.98704005 10.348,0 6.66533333,0 L6.66533333,0 C2.98266667,0 0,2.98704005 0,6.6688336 L0,6.6688336 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "1.18423789e-15 0 45.3333333 0 45.3333333 58.6733342 1.18423789e-15 58.6733342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.95814026 C0,10.8018169 3.11373913,13.9162805 6.95652174,13.9162805 L6.95652174,13.9162805 C10.797913,13.9162805 13.9130435,10.8018169 13.9130435,6.95814026 L13.9130435,6.95814026 C13.9130435,3.11585521 10.797913,0 6.95652174,0 L6.95652174,0 C3.11373913,0 0,3.11585521 0,6.95814026 L0,6.95814026 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4768696,0 L19.4768696,5.56512058 L2.78121739,5.56512058 L2.78121739,0 L0,0 L0,6.95674864 C0,7.72492732 0.623304348,8.34837669 1.39130435,8.34837669 L1.39130435,8.34837669 L20.8681739,8.34837669 C21.6375652,8.34837669 22.2594783,7.72492732 22.2594783,6.95674864 L22.2594783,6.95674864 L22.2594783,0 L19.4768696,0 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94290599e-15,1.39301968 L4.94290599e-15,14.2085224 C4.94290599e-15,14.9767011 0.623304348,15.6001505 1.39269565,15.6001505 L1.39269565,15.6001505 C2.16069565,15.6001505 2.784,14.9767011 2.784,14.2085224 L2.784,14.2085224 L2.784,1.39301968 C2.784,0.62205774 2.16069565,0 1.39269565,0 L1.39269565,0 C0.623304348,0 4.94290599e-15,0.62205774 4.94290599e-15,1.39301968 L4.94290599e-15,1.39301968 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5384348,0.409138647 L6.96243478,5.00151122 L2.38365217,0.409138647 C1.83965217,-0.136379549 0.954782609,-0.136379549 0.408,0.409138647 L0.408,0.409138647 C-0.136,0.954656844 -0.136,1.83973229 0.408,2.38525048 L0.408,2.38525048 L5.9746087,7.95176269 C6.23617391,8.21199714 6.59095652,8.35672646 6.96243478,8.35672646 L6.96243478,8.35672646 C7.33113043,8.35672646 7.68730435,8.21199714 7.94886957,7.95176269 L7.94886957,7.95176269 L13.5154783,2.38525048 C14.0608696,1.83973229 14.0608696,0.954656844 13.5154783,0.409138647 L13.5154783,0.409138647 C13.2427826,0.136379549 12.8852174,0 12.5276522,0 L12.5276522,0 C12.170087,0 11.8125217,0.136379549 11.5384348,0.409138647 L11.5384348,0.409138647 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-17",
    points: "0 0 47.3040696 0 47.3040696 61.2316343 0 61.2316343"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC8E-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "record-card-imgs/certified/medium",
    transform: "translate(-61.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "imgs",
    transform: "translate(61.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Brand/48px/BirthsDeathsMarriages",
    transform: "translate(3.333333, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.668800, 37.330000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#202D60",
    mask: "url(#mask-2)",
    points: "-1.33333333 28.0048339 28 28.0048339 28 -1.33216652 -1.33333333 -1.33216652"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(35.682642, 45.652373)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#202D60",
    mask: "url(#mask-4)",
    points: "-1.46717537 12.6429137 16.606158 12.6429137 16.606158 -1.40684252 -1.46717537 -1.40684252"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#202D60",
    points: "28 14.6678335 28 33.3368338 32 28.0028337 36 33.3368338 36 14.6678335"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(25.334133, 6.666167)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#D61E3A",
    mask: "url(#mask-6)",
    points: "-1.33466667 14.6698337 14.6653333 14.6698337 14.6653333 -1.33216652 -1.33466667 -1.33216652"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,40.0043339 C8.596,40.0043339 8,40.6017419 8,41.3378339 C8,42.0752594 8.596,42.6713339 9.33333333,42.6713339 L30.156,42.6713339 C30.7106667,41.7138809 31.3613333,40.8231029 32.0946667,40.0043339 L9.33333333,40.0043339 Z",
    id: "Fill-11",
    fill: "#202D60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,46.671834 C8.596,46.671834 8,47.269242 8,48.005334 C8,48.7427595 8.596,49.338834 9.33333333,49.338834 L28.0693333,49.338834 C28.144,48.424053 28.304,47.535942 28.5253333,46.671834 L9.33333333,46.671834 Z",
    id: "Fill-13",
    fill: "#202D60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,56.0063341 C4.45733333,56.0063341 2.66666667,54.2154436 2.66666667,52.0058341 L2.66666667,13.9344085 L13.3333333,4.33320832 L13.3333333,14.6678335 L6.66666667,14.6678335 L6.66666667,17.3348335 L16,17.3348335 L16,2.66633329 L38.6666667,2.66633329 C40.8746667,2.66633329 42.6666667,4.45855732 42.6666667,6.66683335 L42.6666667,34.7316748 C43.108,34.6956703 43.5506667,34.6636663 44.0026667,34.6636663 C44.452,34.6636663 44.8933333,34.6956703 45.3333333,34.7316748 L45.3333333,6.66683335 C45.3333333,2.9850398 42.348,-0.00066675001 38.6666667,-0.00066675001 L14.6666667,-0.00066675001 C14.336,0.00066675001 14.0173333,0.124682252 13.772,0.346043255 L0.438666667,12.3475434 C0.16,12.5995749 1.18423789e-15,12.9582865 1.18423789e-15,13.3343335 L1.18423789e-15,52.0058341 C1.18423789e-15,53.7740551 0.701333333,55.4702671 1.952,56.7210901 C3.20133333,57.9719132 4.89866667,58.6733342 6.66666667,58.6733342 L30.164,58.6733342 C29.676,57.8305622 29.2653333,56.9384506 28.9346667,56.0063341 L6.66666667,56.0063341 Z",
    id: "Fill-15",
    fill: "#202D60",
    mask: "url(#mask-8)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(98.478261, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(26.434783, 6.958140)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#D61E3A",
    mask: "url(#mask-10)",
    points: "-1.39130435 15.3079086 15.3043478 15.3079086 15.3043478 -1.39162805 -1.39130435 -1.39162805"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PDF",
    transform: "translate(7.167443, 24.535793)",
    fill: "#202D60",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11.6869565 L2.57113043,11.6869565 L2.57113043,8.18086957 L4.52452174,8.18086957 C7.14573913,8.18086957 9.2493913,6.77843478 9.2493913,4.07373913 L9.2493913,4.04034783 C9.2493913,1.65286957 7.56313043,0 4.77495652,0 L0,0 L0,11.6869565 Z M2.57113043,5.89356522 L2.57113043,2.32069565 L4.55791304,2.32069565 C5.84347826,2.32069565 6.64486957,2.93843478 6.64486957,4.09043478 L6.64486957,4.12382609 C6.64486957,5.12556522 5.89356522,5.89356522 4.608,5.89356522 L2.57113043,5.89356522 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1526957,11.6869565 L15.7106087,11.6869565 C19.3836522,11.6869565 21.9213913,9.13252174 21.9213913,5.84347826 L21.9213913,5.81008696 C21.9213913,2.52104348 19.3836522,0 15.7106087,0 L11.1526957,0 L11.1526957,11.6869565 Z M13.7238261,9.36626087 L13.7238261,2.32069565 L15.7106087,2.32069565 C17.8142609,2.32069565 19.2333913,3.77321739 19.2333913,5.84347826 L19.2333913,5.87686957 C19.2333913,7.94713043 17.8142609,9.36626087 15.7106087,9.36626087 L13.7238261,9.36626087 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "24.2086957 11.6869565 26.7798261 11.6869565 26.7798261 7.16243478 32.3561739 7.16243478 32.3561739 4.82504348 26.7798261 4.82504348 26.7798261 2.3373913 33.1074783 2.3373913 33.1074783 0 24.2086957 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.6457739,64 L36.167513,64 C35.399513,64 34.7762087,63.3765506 34.7762087,62.6083719 L34.7762087,55.6502317 L37.5588174,55.6502317 L37.5588174,61.2167439 L54.2544696,61.2167439 L54.2544696,55.6502317 L57.0370783,55.6502317 L57.0370783,62.6083719 C57.0370783,63.3765506 56.4151652,64 55.6457739,64",
    id: "Fill-4",
    fill: "#202D60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(34.777043, 55.651206)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#202D60",
    mask: "url(#mask-12)",
    points: "-1.39269565 9.74000474 23.6507826 9.74000474 23.6507826 -1.39301968 -1.39269565 -1.39301968"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.9066435,57.3339625 C45.1386435,57.3339625 44.5153391,56.7105131 44.5153391,55.9423344 L44.5153391,43.12544 C44.5153391,42.3558697 45.1386435,41.733812 45.9066435,41.733812 C46.6760348,41.733812 47.2979478,42.3558697 47.2979478,43.12544 L47.2979478,55.9423344 C47.2979478,56.7105131 46.6760348,57.3339625 45.9066435,57.3339625",
    id: "Fill-9",
    fill: "#202D60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(44.514783, 41.733534)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#202D60",
    mask: "url(#mask-14)",
    points: "-1.39130435 16.9917785 4.17391304 16.9917785 4.17391304 -1.39162805 -1.39130435 -1.39162805"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.9066435,58.4334976 C45.5365565,58.4348794 45.1817739,58.2887585 44.9188174,58.0299157 L39.3536,52.4634034 C38.8082087,51.9164936 38.8082087,51.0328098 39.3536,50.4872916 C39.9003826,49.9403818 40.7838609,49.9403818 41.3292522,50.4872916 L45.9066435,55.0796642 L50.4840348,50.4872916 C51.0308174,49.9403818 51.9142957,49.9403818 52.459687,50.4872916 C53.0064696,51.0328098 53.0064696,51.9164936 52.459687,52.4634034 L46.8944696,58.0299157 C46.631513,58.2887585 46.2767304,58.4348794 45.9066435,58.4334976",
    id: "Fill-14",
    fill: "#202D60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(38.945043, 50.077735)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#202D60",
    mask: "url(#mask-16)",
    points: "-1.52730435 9.74974614 15.4521739 9.74974614 15.4521739 -1.5280076 -1.52730435 -1.5280076"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95624348,15.3079086 L6.95624348,18.0911647 L16.6953739,18.0911647 L16.6953739,2.78325611 L40.3475478,2.78325611 C42.6529391,2.78325611 44.5214609,4.65360421 44.5214609,6.95814026 L44.5214609,39.1311892 C44.9318957,39.0129008 45.4021565,38.9391445 45.9113739,38.9391445 C46.4219826,38.9391445 46.8936348,39.0129008 47.3040696,39.1325808 L47.3040696,6.95814026 C47.3040696,3.11446358 44.1889391,0 40.3475478,0 L15.3040696,0 C14.9590261,0.00139162805 14.6278957,0.130813037 14.3718957,0.361823294 L0.458852174,12.8864758 C0.168069565,13.1494935 0.00111304348,13.5238414 -0.00027826087,13.9162805 L-0.00027826087,54.2734941 C-0.00027826087,56.1187928 0.73293913,57.8889437 2.03798261,59.1942908 C3.34163478,60.499638 5.11137391,61.2316343 6.95624348,61.2316343 L31.9941565,61.2316343 L31.9941565,58.4483782 L6.95624348,58.4483782 C4.65085217,58.4483782 2.78233043,56.5794217 2.78233043,54.2734941 L2.78233043,14.5425131 L13.9127652,4.52279117 L13.9127652,15.3079086 L6.95624348,15.3079086 Z",
    id: "Fill-19",
    fill: "#202D60",
    mask: "url(#mask-18)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "plus",
    fontFamily: "Gotham-Bold, Gotham",
    fontSize: 22,
    fontWeight: "bold",
    "line-spacing": 30,
    fill: "#202D60"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 70,
    y: 32
  }, "+")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertifiedFrameless);
export default __webpack_public_path__ + "static/media/certified-frameless.032d5aec.svg";
export { ForwardRef as ReactComponent };